import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

import { useAccountStore } from '@/stores/account';
import { useDialogStore } from '@/stores/dialogs';
import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import AddProgramDialog from './dialogs/AddProgramDialog.vue';
import AddTeamDialog from './dialogs/AddTeamDialog.vue';
import AddUserDialog from './dialogs/AddUserDialog.vue';
import CreateLimitsReportDialog from './dialogs/CreateLimitsReportDialog.vue';
import CreateReportDialog from './dialogs/CreateReportDialog.vue'
import CreateSupervisorReportDialog from './dialogs/CreateSupervisorReportDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

const uiStore = useUiStore()
const accountStore = useAccountStore()
const programsStore = useProgramsStore()

const router = useRouter()
const page = computed(() => {
  const path = router.currentRoute.value.path

  if (path === "/account") return "account"
  if (path.startsWith("/programs")) return "programs"
  if (path === "/trackers") return "trackers"
  if (path === "/feedback") return "feedback"
  return "other"
})

const title = computed(() => {
  const pageName = router.currentRoute.value.name

  if (page.value === "account") return "Аккаунт"
  if (page.value === "trackers") return "Трекеры"
  if (page.value === "feedback") return "Обратная связь"
    
  if (page.value === "programs") {
    const program = programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId)
    return program?.name || "Программа"
  }

  return "MBA"
})

const dialogStore = useDialogStore()
const addUser = () => {
  dialogStore.open(AddUserDialog)
}

const addTeam = () => {
  dialogStore.open(AddTeamDialog)
}

const addReport = (type: "weekly" | "limit") => {
  if (type === "weekly") {
    dialogStore.open(CreateReportDialog)
  }
  if (type === "limit") {
    dialogStore.open(CreateLimitsReportDialog)
  }
}

const addSupervisorReport = () => {
  dialogStore.open(CreateSupervisorReportDialog)
}

const editProgram = () => {
  const program = programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId)
  if (!program) return
  dialogStore.open(AddProgramDialog, { program })
}

const logout = () => {
  accountStore.logout()
}


return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { height: "60" }, {
    default: _withCtx(() => [
      (!_unref(uiStore).drawer)
        ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiStore).drawer = !_unref(uiStore).drawer)),
            class: "rounded-circle"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_toolbar_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(title)) + " ", 1),
          (_unref(page) === 'programs' && _unref(accountStore).isDirector)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                icon: "mdi-pencil",
                size: "small",
                style: {"opacity":"0.6"},
                onClick: editProgram
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_unref(page) !== 'account' && _unref(accountStore).isDirector)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_btn, {
              variant: "flat",
              height: "32",
              class: "mr-3",
              color: "primary",
              "append-icon": "mdi-plus",
              onClick: addUser
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить сотрудника ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              variant: "tonal",
              height: "32",
              color: "primary",
              "append-icon": "mdi-plus",
              onClick: addTeam
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить команду ")
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      (_unref(page) !== 'account' && !_unref(accountStore).isDirector)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_v_menu, { "open-on-hover": "" }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  variant: "flat",
                  height: "32",
                  class: "mr-3",
                  color: "primary",
                  "append-icon": "mdi-plus"
                }, props), {
                  default: _withCtx(() => [
                    _createTextVNode(" Добавить отчет трекера ")
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      value: "1",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (addReport('weekly')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Еженедельный")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, {
                      value: "2",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (addReport('limit')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("По ограничениям")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(accountStore).isSupervisor)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  variant: "tonal",
                  height: "32",
                  class: "mr-3",
                  color: "primary",
                  "append-icon": "mdi-plus",
                  onClick: addSupervisorReport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Добавить отчет супервайзера ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_v_menu, { "open-on-hover": "" }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, {
            icon: "",
            "x-large": "",
            size: "34",
            class: "ml-3 mr-5 rounded-circle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_avatar, _mergeProps({
                color: "primary",
                size: "34"
              }, props, {
                image: _unref(accountStore).currentUser?.avatar
              }), null, 16, ["image"])
            ]),
            _: 2
          }, 1024)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, { class: "text-right rounded" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                class: "text-left",
                value: "1",
                onClick: logout
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Выйти из аккаунта")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})